export const MAX_VISIBLE_PHONE_NUMBERS = 3;